import { defineMessages } from 'react-intl'

export const COACH_INTENSITY_LEVEL = {
  NOT_INTENSE: 'NOT_INTENSE',
  LITTLE_INTENSE: 'LITTLE_INTENSE',
  INTENSE: 'INTENSE',
  DONT_NEED_A_COACH: 'DONT_NEED_A_COACH'
}
export const COACH_INTENSITY_LEVELS = Object.values(COACH_INTENSITY_LEVEL)

export const messages = defineMessages({
  notIntense: {
    id: 'coachIntensityLevel.notIntense',
    defaultMessage: 'Not intense'
  },
  littleIntense: {
    id: 'coachIntensityLevel.littleIntense',
    defaultMessage: 'A little intense'
  },
  intense: {
    id: 'coachIntensityLevel.intense',
    defaultMessage: 'Intense'
  },
  dontNeedACoach: {
    id: 'coachIntensityLevel.dontNeedACoach',
    defaultMessage: 'I don’t need a coach'
  }
})

export const messageHelper = defineMessages({
  notIntense: {
    id: 'coachIntensityLevelHelper.notIntense',
    defaultMessage: 'Just provide me with guidance'
  },
  littleIntense: {
    id: 'coachIntensityLevelHelper.littleIntense',
    defaultMessage: 'Tell me when I’m slacking off'
  },
  intense: {
    id: 'coachIntensityLevelHelper.intense',
    defaultMessage: 'Point out every mistake I make'
  },
  dontNeedACoach: {
    id: 'coachIntensityLevelHelper.dontNeedACoach',
    defaultMessage: 'I know what I’m doing'
  }
})

export const COACH_INTENSITY_LEVEL_MESSAGE = {
  [COACH_INTENSITY_LEVEL.NOT_INTENSE]: messages.notIntense,
  [COACH_INTENSITY_LEVEL.LITTLE_INTENSE]: messages.littleIntense,
  [COACH_INTENSITY_LEVEL.INTENSE]: messages.intense,
  [COACH_INTENSITY_LEVEL.DONT_NEED_A_COACH]: messages.dontNeedACoach
}

export const COACH_INTENSITY_LEVEL_MESSAGE_HELPER = {
  [COACH_INTENSITY_LEVEL.NOT_INTENSE]: messageHelper.notIntense,
  [COACH_INTENSITY_LEVEL.LITTLE_INTENSE]: messageHelper.littleIntense,
  [COACH_INTENSITY_LEVEL.INTENSE]: messageHelper.intense,
  [COACH_INTENSITY_LEVEL.DONT_NEED_A_COACH]: messageHelper.dontNeedACoach
}
